import React, { useContext } from "react";
import backBtn from "../../img/back_btn.png";
import { AppContext } from "../../context";
import { translateText } from "../../context/utils";
import SafeImage from "../SafeImage";

const NavbarP = () => {
  const { config, screen, currentBlock, clientId } = useContext(AppContext);

  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text)) {
      return config["language"][text];
    } else {
      // const data = translateText(text, config["language"]["langCode"]);
      return text;
    }
  };

  const switchBack = () => {};

  const title =
    currentBlock["name"] === "Form Module Portrait"
      ? "Form fill up"
      : ["Optional"].includes(currentBlock["tag"])
        ? "Additional photos"
        : ["vecfleet_prod"].includes(clientId)
          ? config["blocks"][0]["id"]
          : "360 Image";

  // Shrink the heading just enough to keep it on a single line: the navbar
  // gives up 20px of left margin and 86px to the logo, and a bold glyph in
  // this font averages ~0.58em wide.
  const titleText = String(title || "");
  const titleFontSize = Math.max(
    13,
    Math.min(24, (window.innerWidth - 114) / (titleText.length * 0.58 || 1))
  );

  return (
    <div id="portNavbar" style={{ backgroundColor: config["colors"]["nav"] }}>
      <div
        id="tagAndArrow"
        style={{
          display: "flex",
          justifyContent: "space-between",
          flex: 1,
          minWidth: 0,
          marginLeft: "20px",
          alignItems: "center",
        }}
      >
        {/* {screen !== "pMenu"? <img id="backbtnLogo" alt="" src={backBtn} onClick={switchBack} style={{width: "30px"}}/> : ""} */}
        <h2
          style={{
            color: ["vecfleet_prod"].includes(clientId) ? "black" : "white",
            margin: "0px",
            fontSize: `${titleFontSize}px`,
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </h2>
      </div>
      {config["logo"].length > 0 && (
        <SafeImage id="logoP" alt="" src={config["logo"]} fallback={null} />
      )}
    </div>
  );
};

export default NavbarP;
